let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ipslv")).then(() => parcelRequire('6Naxy'));